module.exports = __webpack_public_path__ + "static/media/eye.49ff1e22.svg";